















import { sleep } from '@/libs/util';
import DictMixin from '@/mixins/dict-mixin';
import AnalyzeCustomServices, { DataItem } from '@/services/analyzeCustom';
import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class CustomTableView extends mixins(DictMixin) {
  @Prop() info!: DataItem;
  @Prop() reload!: number;
  loading: boolean = false;

  columns: any[] = [];
  dataSource: any[] = [];
  groupByField: string = '';
  groupByFieldList: any[] = [];
  dimFieldCodes: string = '';
  dimFieldCodesList: any[] = [];

  created() {
    this.onVisibleChange();
  }

  customSrv = new AnalyzeCustomServices();
  @Watch('reload')
  async onVisibleChange() {
    this.groupByFieldList = this.info.dimensionList || [];
    this.groupByField = (this.info.dimensionList || [])[0]?.fieldCode;
    this.dimFieldCodesList = [];
    this.info.measureList.forEach((v: any) => {
      if (!this.dimFieldCodesList.find(d => v.refDimFieldCode === d.refDimFieldCode)) {
        this.dimFieldCodesList.push(v);
      }
    });
    this.dimFieldCodes = this.info.measureList[0]?.refDimFieldCode;
    this.getTableData();
  }

  @Watch('groupByField')
  @Watch('dimFieldCodes')
  onGroupByFieldChange() {
    this.getTableData();
  }

  timer: boolean = false;
  async getTableData() {
    if (this.timer) {
      await sleep(50);
      return false;
    }
    this.timer = true;
    this.loading = true;
    let res = await this.customSrv.getCommonPreview({ ...this.info, groupByField: this.groupByField || '', dimFieldCodes: this.dimFieldCodes });
    this.loading = false;
    if (res) {
      this.columns = [];
      let f = this.groupByFieldList.find(v => v.fieldCode === this.groupByField);
      if (f) this.columns.push({ title: f.fieldName, dataIndex: f.fieldCode });
      this.info.measureList.forEach((v: any) => this.columns.push({ title: v.fieldName, dataIndex: v.fieldCode }));
      // this.columns = Object.keys(res.nameMap).map((key: string) => ({ title: res.nameMap[key], dataIndex: key }));
      this.dataSource = res.valueList;
    }
    this.timer = false;
  }
}
